'use client';
import 'devextreme/dist/css/dx.light.css';

import { licenseKey } from '@/devextreme-license';
import config from 'devextreme/core/config';

// Run once on the client to register the license
config({ licenseKey: licenseKey });

function DevexInit() {
  return null;
}

export default DevexInit;
